import { createComponent } from '@helpers/admin';
import BlogsSectionComponent from '@template/blocks/BlogsSection/component';

export const MiniArticles = createComponent({
  label: 'Mini Articles',
  component: BlogsSectionComponent,
  fields: {
    links: {
      label: 'Header Links',
      type: 'array',
      arrayFields: {
        href: {
          label: 'Link',
          type: 'text',
        },
        linkText: {
          label: 'Text',
          type: 'text',
        },
        color: {
          label: 'Color',
          type: 'select',
          options: [
            { value: 'primary', label: 'Primary' },
            { value: 'secondary', label: 'Secondary' },
            { value: 'default', label: 'Default' },
          ],
        },
      },
    },
  },
});
